import { createContext } from "react";

/* =========================
   Types
   ========================= */

export type ContrastMode = "light" | "dark" | "high";

/**
 * AccessibilityState
 * WCAG-oriented functional accessibility system
 */
export type AccessibilityState = {
  /* Font */
  fontSize: number;

  /* Core */
  a11yEnabled: boolean;

  /* Motion */
  reduceMotion: boolean;
  userOverrideReduceMotion: boolean;

  /* Visual helpers */
  highlightLinks: boolean;
  highlightHeadings: boolean;
  readableFont: boolean;

  /* Contrast */
  contrastMode: ContrastMode;
};

/* =========================
   Context API
   ========================= */

export type AccessibilityContextType = {
  state: AccessibilityState;

  /* Core */
  enableA11y: () => void;
  disableA11y: () => void;
  toggleA11y: () => void;

  /* Font */
  setFontSize: (size: number) => void;

  /* Motion */
  toggleReduceMotion: () => void;
  setReduceMotion: (value: boolean) => void;

  /* Visual helpers */
  toggleHighlightLinks: () => void;
  toggleHighlightHeadings: () => void;
  toggleReadableFont: () => void;

  /* Contrast */
  setContrastMode: (mode: ContrastMode) => void;

  /* Presets (future-ready) */
  applyReadingPreset?: () => void;
  applyVisionPreset?: () => void;
  applyAttentionPreset?: () => void;

  /* Reset */
  reset: () => void;
};

/* =========================
   Context
   ========================= */

export const AccessibilityContext = createContext<
  AccessibilityContextType | undefined
>(undefined);
